import {AbstractControl, ValidationErrors} from '@angular/forms';
import {Utils} from '@astek/utils';

export function expirationDateRangeValidator(control: AbstractControl): ValidationErrors | null {
  const expireAtFromControl: AbstractControl<Date | null> | null = control.get('expireAtFrom');
  const expireAtToControl: AbstractControl<Date | null> | null = control.get('expireAtTo');
  if (Utils.isNull(expireAtFromControl) || Utils.isNull(expireAtToControl)) {
    return null;
  }
  switch (true) {
    case Utils.isNull(expireAtFromControl.value) && Utils.isNull(expireAtToControl.value):
      expireAtFromControl.setErrors(null);
      expireAtToControl.setErrors(null);
      break;
    case Utils.isNull(expireAtFromControl.value):
      expireAtFromControl.setErrors({incorrect: true});
      break;
    case Utils.isNull(expireAtToControl.value):
      expireAtToControl.setErrors({incorrect: true});
      break;
    case Utils.isNotNull(expireAtFromControl.value) && Utils.isNotNull(expireAtToControl.value) &&
    expireAtToControl.value < expireAtFromControl.value:
      expireAtToControl.setErrors({incorrect: true});
      break;
    default:
      expireAtFromControl.setErrors(null);
      expireAtToControl.setErrors(null);
  }
  return null;
}
